export const services = [
  {
    id: 1,
    title: "Mobile Tyre Fitting",
    description: "We come to you — at home, work, or roadside. Our fully-equipped vans carry a wide range of tyres to fit most vehicles on the spot.",
    image: "https://public.readdy.ai/ai/img_res/7336cb201b59d53d2ee8dbae4901ee69.jpg",
    icon: "ri-steering-2-line",
    wide: true
  },
  {
    id: 2,
    title: "Puncture Repair",
    description: "Fast, reliable puncture repairs using industry-standard techniques.",
    image: "https://readdy.ai/api/search-image?query=close%20up%20of%20professional%20mechanic%20repairing%20a%20car%20tyre%20puncture%2C%20removing%20nail%20from%20tread%2C%20repair%20tools%20visible%2C%20clean%20concrete%20floor%2C%20bright%20workshop%20lighting%2C%20photorealistic%20automotive%20detail%20photography&width=400&height=300&seq=bf002&orientation=landscape",
    icon: "ri-tools-line",
    wide: false
  },
  {
    id: 3,
    title: "Wheel Balancing",
    description: "Eliminate vibrations and uneven wear with precision wheel balancing.",
    image: "https://readdy.ai/api/search-image?query=wheel%20balancing%20machine%20with%20silver%20alloy%20wheel%20mounted%2C%20professional%20automotive%20equipment%2C%20clean%20modern%20workshop%2C%20technical%20precision%20photography%2C%20high%20quality%20automotive%20service%20setting&width=400&height=300&seq=bf003&orientation=landscape",
    icon: "ri-compass-3-line",
    wide: false
  },
  {
    id: 4,
    title: "TPMS Services",
    description: "Full TPMS sensor diagnostics, replacement and recalibration.",
    image: "https://readdy.ai/api/search-image?query=TPMS%20tyre%20pressure%20monitoring%20sensor%20installation%20on%20car%20wheel%20valve%2C%20close%20up%20technical%20automotive%20photography%2C%20professional%20mechanic%20hands%2C%20modern%20diagnostic%20equipment%2C%20clean%20background&width=400&height=300&seq=bf004&orientation=landscape",
    icon: "ri-sensor-line",
    wide: false
  }
];

export const products = [
  {
    id: 1,
    brand: "Michelin",
    model: "Pilot Sport 5",
    size: "225/45 R17",
    price: "£129",
    tag: "Premium",
    image: "https://readdy.ai/api/search-image?query=Michelin%20premium%20car%20tyre%20close%20up%20on%20white%20background%2C%20detailed%20tread%20pattern%2C%20studio%20product%20photography%2C%20clean%20minimal%20background%2C%20professional%20automotive%20product%20shot&width=280&height=280&seq=bf005&orientation=squarish"
  },
  {
    id: 2,
    brand: "Pirelli",
    model: "P Zero Nero",
    size: "245/40 R18",
    price: "£149",
    tag: "Sport",
    image: "https://readdy.ai/api/search-image?query=Pirelli%20sport%20car%20tyre%20product%20shot%20on%20clean%20background%2C%20detailed%20tread%20pattern%20close%20up%2C%20studio%20lighting%2C%20premium%20automotive%20product%20photography&width=280&height=280&seq=bf006&orientation=squarish"
  },
  {
    id: 3,
    brand: "Continental",
    model: "PremiumContact 7",
    size: "205/55 R16",
    price: "£99",
    tag: "All-Season",
    image: "https://readdy.ai/api/search-image?query=Continental%20all%20season%20car%20tyre%20close%20up%20on%20plain%20light%20background%2C%20tread%20pattern%20visible%2C%20professional%20studio%20product%20photography%2C%20automotive%20tyre%20product%20image&width=280&height=280&seq=bf007&orientation=squarish"
  },
  {
    id: 4,
    brand: "Bridgestone",
    model: "Turanza T005",
    size: "215/60 R16",
    price: "£89",
    tag: "Comfort",
    image: "https://readdy.ai/api/search-image?query=Bridgestone%20comfort%20touring%20car%20tyre%20product%20photography%20on%20clean%20neutral%20background%2C%20detailed%20rubber%20tread%20pattern%2C%20studio%20lighting%2C%20premium%20product%20shot&width=280&height=280&seq=bf008&orientation=squarish"
  },
  {
    id: 5,
    brand: "Goodyear",
    model: "EfficientGrip 2",
    size: "195/65 R15",
    price: "£79",
    tag: "Eco",
    image: "https://readdy.ai/api/search-image?query=Goodyear%20eco%20efficient%20car%20tyre%20close%20up%20product%20shot%20on%20white%20clean%20background%2C%20tyre%20tread%20detail%2C%20professional%20automotive%20studio%20photography&width=280&height=280&seq=bf009&orientation=squarish"
  },
  {
    id: 6,
    brand: "Dunlop",
    model: "Sport Maxx RT2",
    size: "235/45 R17",
    price: "£109",
    tag: "Performance",
    image: "https://readdy.ai/api/search-image?query=Dunlop%20sport%20performance%20car%20tyre%20product%20photography%20on%20clean%20background%2C%20detailed%20tread%20pattern%20rubber%2C%20studio%20lighting%2C%20high%20quality%20automotive%20tyre%20image&width=280&height=280&seq=bf010&orientation=squarish"
  }
];

export const stats = [
  { value: "12+", label: "Years Experience" },
  { value: "28K+", label: "Tyres Fitted" },
  { value: "4.9★", label: "Average Rating" },
  { value: "60min", label: "Response Time" }
];

export const testimonials = [
  {
    id: 1,
    name: "James Thornton",
    location: "Manchester",
    date: "February 2026",
    text: "Absolutely brilliant service! My tyre blew on a Monday morning and BritFit had a technician at my door within the hour. Saved my whole day. Will definitely use again.",
    initials: "JT",
    color: "#D4EDDA"
  },
  {
    id: 2,
    name: "Sarah Mitchell",
    location: "London",
    date: "January 2026",
    text: "Booked online the night before and they arrived bang on time. Fitted two new Michelins and even noticed my third tyre was wearing unevenly — flagged it up at no extra charge. Top-notch.",
    initials: "SM",
    color: "#FDE8D8"
  },
  {
    id: 3,
    name: "David Clarke",
    location: "Birmingham",
    date: "March 2026",
    text: "Used them for the second time this year. Competitive pricing, professional team, and they cleaned up after themselves. Nothing to complain about whatsoever.",
    initials: "DC",
    color: "#E8F4F8"
  },
  {
    id: 4,
    name: "Emma Hartley",
    location: "Leeds",
    date: "December 2025",
    text: "Had a flat tyre in a car park at 7pm. BritFit came out and sorted it in under 45 minutes. Friendly driver and very fair price. Highly recommend to anyone in Leeds.",
    initials: "EH",
    color: "#F5E6FF"
  },
  {
    id: 5,
    name: "Robert Williams",
    location: "Edinburgh",
    date: "January 2026",
    text: "Professional, punctual, and priced well. Got four new Bridgestones fitted on my driveway while I worked from home. Couldn\'t have been easier.",
    initials: "RW",
    color: "#FFF3CD"
  },
  {
    id: 6,
    name: "Priya Sharma",
    location: "Bristol",
    date: "February 2026",
    text: "The technician was incredibly knowledgeable and took time to explain what he was doing. Really reassuring. My car drives so much better now. Five stars without hesitation.",
    initials: "PS",
    color: "#D4EDDA"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How quickly can you come out to fit my tyres?",
    answer: "In most areas we can reach you within 60 minutes for emergency callouts. For scheduled bookings, we offer same-day and next-day slots across our service areas. Book online or call us to check availability near you."
  },
  {
    id: 2,
    question: "What areas do you cover?",
    answer: "We cover a wide range of areas across England, Scotland, and Wales. Our service network is continuously expanding. Enter your postcode on our booking page to check exact availability in your area."
  },
  {
    id: 3,
    question: "Do you carry tyres for all vehicles?",
    answer: "Our vans stock a comprehensive range of tyres for cars, SUVs, vans, and light commercial vehicles. We carry leading brands including Michelin, Pirelli, Continental, Bridgestone, Goodyear, and Dunlop. For specialist or prestige vehicles, please call ahead so we can ensure we have your exact size in stock."
  },
  {
    id: 4,
    question: "Can you fit tyres at my workplace?",
    answer: "Absolutely! We can come to your home, workplace, a car park, or even a roadside location. As long as there is safe access and enough space to work around your vehicle, we can fit your tyres anywhere."
  },
  {
    id: 5,
    question: "Are your tyres covered by a warranty?",
    answer: "Yes. All tyres we supply come with the manufacturer\'s standard warranty. Our fitting workmanship is also guaranteed. If you experience any issue related to our fitting, we will return and rectify it free of charge."
  },
  {
    id: 6,
    question: "How do I pay for the service?",
    answer: "We accept all major credit and debit cards, contactless payment, and bank transfer. Payment is taken on the day of service once the work is completed to your satisfaction. We do not require a deposit for standard bookings."
  }
];
